export default __webpack_public_path__ + "static/media/Old_Top.a4968bda.dwg";